const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBottomLineSimLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 445.23 76.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bottom-line-sim-logo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2-2",
    "data-name": "Group 2-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M45,44.48v.18a15.29,15.29,0,0,1,7.9,5.17,14.6,14.6,0,0,1,2.89,9.3q0,7.71-4.91,12t-14.11,4.3h-27V15.82H35q9.3,0,14.16,4T54,31.08a14.75,14.75,0,0,1-2.41,8.33A13,13,0,0,1,45,44.48ZM41.27,33q0-6.41-7.63-6.4H21.81V39.48H33.65q7.62,0,7.63-6.48Zm-7,17.27H21.81V64.74H34.7c2.75,0,4.82-.55,6.23-1.63s2.1-3,2.1-5.65-.73-4.41-2.19-5.52-3.66-1.67-6.58-1.67Z",
    style: {
      fill: "#2c97d9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M85.37,76.31q-21.3,0-21.3-22.8t21.3-22.79q21.22,0,21.22,22.79T85.37,76.31Zm7.15-32.7c-1.37-2.28-3.76-3.42-7.15-3.42s-5.77,1.14-7.14,3.42-2.06,5.58-2.06,9.9.69,7.72,2.06,10,3.75,3.42,7.14,3.42,5.77-1.14,7.15-3.42,2.06-5.61,2.06-10-.69-7.62-2.06-9.9Z",
    style: {
      fill: "#2c97d9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M119.31,62.9V39.75h-5.88V32.3l5.88-.71,1.4-12.27h10V31.59h11v8.16h-11V60.88a6.64,6.64,0,0,0,1.49,4.73c1,1.06,2.63,1.58,4.91,1.58a19.51,19.51,0,0,0,4-.44l1,8.77a43.38,43.38,0,0,1-8.95.79q-7.45,0-10.65-3.2T119.31,62.9Z",
    style: {
      fill: "#2c97d9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M154.81,62.9V39.75h-5.87V32.3l5.87-.71,1.41-12.27h10V31.59h11v8.16h-11V60.88a6.64,6.64,0,0,0,1.49,4.73c1,1.06,2.63,1.58,4.91,1.58a19.6,19.6,0,0,0,4-.44l1,8.77a43.28,43.28,0,0,1-8.94.79q-7.46,0-10.66-3.2T154.81,62.9Z",
    style: {
      fill: "#2c97d9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M204,76.31q-21.3,0-21.3-22.8T204,30.72q21.23,0,21.22,22.79T204,76.31Zm7.15-32.7q-2.07-3.42-7.15-3.42t-7.14,3.42c-1.38,2.28-2.06,5.58-2.06,9.9s.68,7.72,2.06,10,3.75,3.42,7.14,3.42,5.77-1.14,7.15-3.42,2.06-5.61,2.06-10-.69-7.62-2.06-9.9Z",
    style: {
      fill: "#2c97d9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M245.82,43.52V75.44h-11.4V31.6h11.4v5.7H246q6-6.59,13.68-6.58,8.85,0,11.75,7.28,6.48-7.28,15.17-7.28,6.48,0,9.82,3.9c2.22,2.61,3.33,6.21,3.33,10.83v30h-11.4V48.08q0-7.89-7-7.9-3.6,0-8.59,3.42c0,.47,0,1.26,0,2.37s0,2,0,2.63V75.44H261.43V47.55q-.27-7.36-7-7.36Q251,40.19,245.82,43.52Z",
    style: {
      fill: "#2c97d9"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M317.38,0h5.1V51H346.2v4.55H317.38Z",
    style: {
      fill: "#4bab43"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M356,8.7h4.83v8.21H356Zm0,12.41h4.83V55.58H356Z",
    style: {
      fill: "#4bab43"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M376.11,29.11V55.57h-4.83V21.11h4.83v5h.14q5.92-5.72,12.82-5.72,10.33,0,10.34,11.31V55.58h-4.83V32.76q0-8.28-7.58-8.27Q382,24.49,376.11,29.11Z",
    style: {
      fill: "#4bab43"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M438.63,39h-24.2q.21,13.23,12.34,13.24a37.58,37.58,0,0,0,10.76-1.38l.62,3.93a44.69,44.69,0,0,1-12.07,1.51q-16.87,0-16.88-17.92t16.47-17.92q7.24,0,10.27,3.58a13.76,13.76,0,0,1,3.17,8.83A28.66,28.66,0,0,1,438.63,39ZM425.39,24.21q-10.06,0-11,11.58h19.51a12.64,12.64,0,0,0,.28-4.07q-.56-7.5-8.83-7.51Z",
    style: {
      fill: "#4bab43"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M435.66,76.31H309.13V66.76h136.1Z",
    style: {
      fill: "#2c97d9"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M309.13,5H4.85L0,0H309.13Z",
    style: {
      fill: "#4bab43"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomLineSimLogo);
export default __webpack_public_path__ + "static/media/bottom-line-sim-logo.61f99db06fbe092edbadb685985782a3.svg";
export { ForwardRef as ReactComponent };